import { render, staticRenderFns } from "./MoiPoiTags.vue?vue&type=template&id=7bac24e4&scoped=true&"
import script from "./MoiPoiTags.vue?vue&type=script&lang=js&"
export * from "./MoiPoiTags.vue?vue&type=script&lang=js&"
import style0 from "./MoiPoiTags.vue?vue&type=style&index=0&id=7bac24e4&lang=scss&scoped=true&"
import style1 from "./MoiPoiTags.vue?vue&type=style&index=1&id=7bac24e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac24e4",
  null
  
)

export default component.exports